import logo from './logo.png';
import './App.css';

import { User } from './user/user';

function App() {

  return (<div>

    {
      `${window.location.search}`.includes('?q=') ?
        <User />
        :
        <div className="App">
          <header className="App-header">

            <div>
              <div className='text'>Привлекаем инвестиции</div>
              <div className='text'>Ищем соучредителя финансово профиля.</div>

              <div className='text'>Уважаемые инвесторы и потенциальные партнеры!</div>

              <div className='text'>Мы разрабатываем и хотим запустить перспективный и очень необходимый сейчас проект PriceChat</div>
              <div className='text'>Ориентированный на отечественного пользователя в первую очередь и уже потом и для всех остальных стран. Наша цель заполнить вакуум созданный социальной потребностью бизнеса, предпринимателей, само занятых и простых граждан ведущих активный образ жизни с уходом из Российского интернет пространства иностранных компаний. С самым популярным в прошлом в России социальной сетью instagram . ( Instagram в России признан экстремистской организацией, и доступ к платформе ограничен )</div>

              <div className='text'>Российский наш PriceChat полностью покроет потребности бизнеса и граждан с удобном сервисе коммуникаций для заработка и личностного развития.</div>
              <div className='text'>Уникальные возможности PriceChat дополнят и усилят собственное развитие внутри страны и за её пределами.</div>

              <div className='text'>
                <div>Инвесторам предлагается:</div>
                <div>- доля участия в бизнесе</div>
                <div>- прозрачная отчётность и регулярное информирование о развитии проекта</div>
                <div>- возможность значительного увеличения капитала благодаря высокому потенциалу роста отрасли.</div>
              </div>

              <div className='text'>Также рассмотрим любые варианты реализации проекта вплоть до полной продажи ради массового запуска проекта.</div>
            </div>

            <img src={logo} className="App-logo" alt="logo" />

            <div className='text'>
              <code>PriceChat</code> это два в одном.
            </div>

            <div className='text'>
              Это простой и удобный мессенджер/социальная сеть.
            </div>
            
            <div className='text'>
              Это площадка для заработка на продажах товаров и услуг.
            </div>

            <div>
              <div className='text'>Пожалуйста свяжитесь с нами по телефону если заинтересовал наш проект 89281400120 (можно MAX) </div>
              <div className='text'>Или напишите нам на Почту rmp2020@yandex.ru</div>
            </div>

            <div>
              <div className='text'>Ознакомиться с демо версией можно на андроид смартфоне скачав по этой ссылке (<a className="App-link" href="\pricechat.apk">Скачать</a>) при этом необходимо разрешить установку приложений из альтернативных источников. </div>
              <div className='text'>Далее читая текст внутри приложения вы будете одним из самых первых кто полностью с ним ознакомится  и увидит первую демо версию самого популярного в будущем Российского приложение PriceChat .</div>
            </div>

          </header>
        </div>
    }



  </div>

  );
}

export default App;
